import { useState } from 'react';
export const useProvisioningMutation = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);
    const fetchSignedToken = async (cluster_base_url, nonce, org_id, defaultHeaders, scim_per_org_enabled, scim_base_url) => {
        setLoading(true);
        setError(null);
        setData(null);
        const targetUrl = `${scim_base_url}/v1/token/sign`;
        try {
            const response = await fetch(targetUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `${defaultHeaders.accessToken}%20%20${nonce}`,
                    ...defaultHeaders,
                },
                body: JSON.stringify({
                    clusterUrl: cluster_base_url,
                    orgId: org_id,
                    scim_per_org_enabled,
                }),
            });
            if (!response.ok) {
                throw new Error(`Request failed with status ${response.status}`);
            }
            const json = await response.json();
            setData(json);
        }
        catch (err) {
            setError(err);
        }
        finally {
            setLoading(false);
        }
    };
    return { fetchSignedToken, loading, data, error };
};
//# sourceMappingURL=useProvisioningCustomHook.js.map